/* eslint-disable camelcase */
/** 全局配置表 */
// 协议
const protocol = window.protocal ? window.protocal : process.env.NODE_ENV === 'production' ? 'https' : 'https';
// mock环境
const mock_baseUrl = `${protocol}://101.200.54.239:7777/mock/5cff05ef3b9c0c22d4b7bbe1`;

// 开发(联调)环境
const dev_baseUrl = `${protocol}://yubaitong-api-dev-go.datouit.com`; // 开发环境
// 测试环境
const test_baseUrl = `${protocol}://yubaitong-api-dev-go.datouit.com`; // 测试环境
// 生产环境

const pro_baseUrl = `${protocol}://yubaitong-api-dev-go.datouit.com`; // 开发环境

// 插件入口
export const units = {
    group: true, // 分类
    goodsExt: false // 商品额外设置
};



// 静态图片域名 - OSS
export const oss_baseUrl = `${protocol}://img.ybt-baby.com/`;
export const ossBaseUrl = `${protocol}://img.ybt-baby.com/`;
export const AREA_OSS = getAreaUrl();
// 项目logo
export const logo = oss_baseUrl + '/static/logo.png';
export const staticImg = oss_baseUrl + '/static/';

export const role = [
    {
        name: 'VIP',
        id: 1
    },
    {
        name: '三级消费商',
        id: 2
    },
    {
        name: '二级消费商',
        id: 3
    },
    {
        name: '一级消费商',
        id: 4
    },
    {
        name: '合伙人',
        id: 5
    },
    {
        name: '创始人',
        id: 6
    }
];

export const roleMap = {
    0: '普通用户',
    1: 'VIP',
    2: '三级消费商',
    3: '二级消费商',
    4: '一级消费商',
    5: '合伙人',
    6: '创始人'
};

export const level = [
    {
        name: '社区代理',
        id: 1
    },
    {
        name: '区县代理',
        id: 2
    },
    {
        name: '市级代理',
        id: 3
    },
    {
        name: '运营中心',
        id: 4
    }
];

export const levelMap = {
    0: '普通',
    1: '社区代理',
    2: '区县代理',
    3: '市级代理',
    4: '运营中心'
};

// api请求地址
export const baseUrl = getBaseUrl();

// 高德地图api凭据
export const amapKey = '223462ea0c0e146bf4a405031a9fd2d7';

// qq地图 key
export const qqMapKey = 'YIMBZ-BDLCB-R5QUZ-JUP7V-F7F6H-ESB33';

// 错误码常量
export const errCode = {
    5001001: '未获取到token',
    5001002: '无效的token',
    5001003: '注册失败',
    5001004: '用户异常'
};

export const themeColor = '#E43939';

// 请求地址处理
function getBaseUrl() {
    let currentUrl = '';
    switch (process.env.NODE_ENV) {
        case 'mock':
            currentUrl = mock_baseUrl;
            break;
        case 'development':
            currentUrl = dev_baseUrl;
            break;
        case 'test':
            currentUrl = test_baseUrl;
            break;
        case 'production':
            currentUrl = pro_baseUrl;
            break;
    }
    // 全局域名覆盖(有值就覆盖 一般不使用)
    if (window.domain) {
        console.log(999999, window.domain);
        currentUrl = `${protocol}://${window.domain}`;
    }
    return currentUrl;
}

function getAreaUrl(){
    let currentUrl = ossBaseUrl + 'area/allArea20.json';

    if (window.domain) {
        currentUrl = ossBaseUrl + 'area2/allArea20.json';
    }
    return currentUrl;
}
